<div class="container-fluid px-0" style="background-image: url('assets/images/Vector.png'); min-height: 100vh;background-color: rgba(35, 113, 211, 0.03);">
    <div class="heading-top bg-white d-flex pb-0">
        <div class="h6 font-weight-bold pt-1 sm-22">
            <img src="assets/images/key.png" alt="Verify your account" class="mr-2 key">
            Verify your account
        </div>
        <div class="sendMoney-timeline" style="margin-left: 20%;">
            <ul class="timeline m-0 pt-1 px-5" id="timeline">
                <li class="li complete" >
                    <div class="status pl-0 px-3">
                        <p class="sm-12 m-neg color-royalblue">Name</p>
                    </div>
                </li>
                <li class="li" [ngClass]="{'complete': isMarkAddress}">
                    <div class="status pl-0 px-3">
                        <p class="sm-12 m-neg color-royalblue">Address</p>
                    </div>
                </li>
                <li class="li" [ngClass]="{'complete':isMarkPhone}">
                    <div class="status pl-0 px-3">
                        <p class="sm-12 m-neg color-royalblue">Phone</p>
                    </div>
                </li>
                <li class="li"  [ngClass]="{'complete': isMarkDocument}">
                    <div class="status pl-0 px-3 border-0">
                        <p class="sm-12 m-neg color-royalblue">ID card</p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div *ngIf="!step" class="row m-0">
        <div class="col-md-6 col-12 head-top">
            <div class="div">
                <h6 class="primary-text font-weight-bold sm-18 mb-3">Help us secure your account</h6>
                <small class="sm-12 secondary-text mobile16" style="padding-top: 3%;">As a regulated provider of financial services, we need to understand more about you so that we can secure your account and comply with regulations.</small>
                <div class="row m-0">
                    <button (click)="step='name'" class="btn primary-btn px-5 mt-4 btn-widthFull">Next</button>
                </div>
                
            </div>
        </div>
    </div>
    <form  #updateUserForm="ngForm" (ngSubmit)="updateUser(updateUserForm)">
        <div class="row m-0">
            <div class="col-md-6 col-12  mx-0 head-top">
                <!-- <h6 class="pt-3  font-weight-bold">What is your name?</h6>
                    <small class="sm-10 grey-text">Please enter your name is it appears on your identity document.</small> -->
                    <div class="" [ngClass]="{'d-none': step!='name'}">
                        <h6 class="sm-18  primary-text">Please enter your details</h6>
                        <!-- <h6 *ngIf="auth.user?.country_id==233" class="sm-18  primary-text">What is your name?</h6> -->
                        <small class="sm-12 color-lightgray py-3 mobile16">Please enter your legal name, as per your government issued ID.</small>
                        <div class="form-group box-shadows mt-3">
                            <input #formname="ngModel" type="text" name="name"  [(ngModel)]="auth.user.name"
                            class="input_field p-3 w-100  text-grey" (keydown)="common.checkName($event, false, 50)"
                            placeholder="First Name" required>
                        </div>
                        <div class="form-group mt-3 box-shadows">
                            <input #formlastname="ngModel" name="lastname" [(ngModel)]="auth.user.lastname" type="text"
                            class="input_field p-3 w-100 text-grey" (keydown)="common.checkName($event, false, 50)"
                            placeholder="Last Name" required>
                        </div>
                        <div class="form-group box-shadows">
                            <input disabled name="email_id" readonly [(ngModel)]="auth.user.email" type="text"
                            class="input_field p-3 w-100 text-grey d-none" data-pr-form="emailid"
                            id="emailID" required placeholder="Email ID">
                        </div>

                        <!-- <div class="form-group box-shadows">
                            <input disabled name="country" readonly type="text"
                            class="input_field p-3 w-100 text-grey d-none" data-pr-form="emailid"
                            id="country" required value="Canada">
                        </div> -->
                        <!-- <div class="form-group custom-wrap1">
                            <select #addressFormCountry="ngModel"  ngModel class="input_field text-dark p-3 w-100 border-0 box-shadows" name="country" (change)="setStates($event.target.value)" required >
                                <option value="" disabled selected>--- Please select your country ---</option>
                                <option  *ngFor="let country of countries" [value]="country.id"  class="sm-12 h6">{{country.name}}</option>
                            </select>
                        </div> -->
                        <div class="form-group box-shadows mt-1">
                            
                            <select ngModel class="input_field text-dark p-3 w-100 border-0 box-shadows mb-3" name="gender" required >
                                <option value="" disabled selected>--- Please select your gender ---</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Others">Others</option>
                            </select>

                            <p-calendar  required class="input_field w-100 text-dark" name="dob" [(ngModel)]="date1" [showIcon]="true"  required navigator="true" [monthNavigator]="true" [yearNavigator]="true" [yearRange]="yearRange" [defaultDate]="defaultDate" [style]="{'width':'100%'}" [inputStyle]="{'border':'0','color':'black !important'}" placeholder="DOB"></p-calendar>
                            <!-- <input name="dob" ngModel type="text" id="" class="form-control personal-field sm-12 border-0  box-shadows bg-light" required> -->
                        </div>
                        <div class="d-flex justify-content-around address_field mt-4">
                            <button  (click)="step=''"  type="button" class="btn transparent primary-text sm-12 back-btn">Back</button>
                            <!-- <button *ngIf="auth.user.country_id==233" [disabled]="!state.value" (click)="goTo('phone')" type="button" class="btn primary-btn w-100 sm-12 h-auto">Next</button> -->
                            <!-- <button *ngIf="auth.user.country_id!=39" [disabled]="!formname.valid || !formlastname.valid" (click)="goTo('address')" type="button" class="btn  primary-btn sm-12 h-auto w-100 btn-widthFull">Next</button> -->
                            
                            <button [disabled]="!formname.valid || !formlastname.valid || !date1 || !updateUserForm.value.gender" (click)="goTo('address')" type="button" class="btn  primary-btn sm-12 h-auto w-100 btn-widthFull">Next</button>
                        </div>
                        <!-- <button [disabled]="!formname.valid || !formlastname.valid" (click)="goTo('address')" type="button" class="btn px-5 primary-btn sm-12 h-auto mt-3 btn-widthFull">Next</button> -->
                    </div>
                    <div [ngClass]="{'d-none': step!='address'}">
                        <ng-container *ngIf="auth.user.country_id==39">
                            <h6 class="font-weight-bold sm-18 primary-text pb-3">Please enter your address</h6>
                            
                            <!-- <div class="form-group custom-wrap1 form-label box-shadows" style="padding: 2px;">
                                <select #state="ngModel" class="input_field chevrronDown  p-3 w-100 border-0 sm-16 select2 text-dark" name="state" ngModel id="state"  required>
                                    <option  value="" disabled selected>Province</option>
                                    <option *ngFor="let state of states" [value]="state.key">
                                        {{state.value}}
                                    </option>
                                </select>
                            </div> -->
                            <div class="form-group  box-shadows">
                                <input #state="ngModel" type="text" name="state" ngModel class="input_field p-3 w-100"
                                placeholder="State" required>
                            </div>
                            <div class="form-group  box-shadows">
                                <input #addressFormuser_address="ngModel" type="text" name="user_address" ngModel class="input_field p-3 w-100"
                                placeholder="Street" required>
                            </div>
                            <div class="form-group box-shadows">
                                <input #addressFormcity_name="ngModel" type="text" name="city_name" ngModel class="input_field p-3 w-100"
                                placeholder="City" required>
                            </div>
                            <div class="form-group  box-shadows">
                                <input type="text" #addressFormuserstreet="ngModel" name="user_street" ngModel class="input_field p-3 w-100"
                                id="street" placeholder="Apartment number" required>
                            </div>
                            
                            <div class="form-group  box-shadows">
                                <input #addressFormpin_code="ngModel" type="text" name="pin_code" ngModel class="input_field p-3 w-100"
                                placeholder="Post Code" required>
                            </div>
                            <div class="form-group  box-shadows">
                                <input #addressFormMunicipality="ngModel" type="text" name="municipality" ngModel class="input_field p-3 w-100"
                                placeholder="Municipality" required>
                            </div>
                            <div class="d-flex justify-content-around address_field my-4">
                                <button (click)="goTo('name')" type="button" class="btn transparent primary-text sm-12 back-btn">Back</button>          
                                <button [disabled]="!state.valid || !addressFormuser_address.valid || !addressFormuserstreet.valid || !addressFormcity_name.valid || !addressFormpin_code.valid || !addressFormMunicipality.valid" (click)="goTo('phone')" type="button" class="btn primary-btn w-100 sm-12 h-auto">Next</button>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="auth.user.country_id==233">
                            <h6 class="font-weight-bold sm-18 primary-text pb-3">Please enter your address</h6>
                            
                            <div class="form-group custom-wrap1 form-label box-shadows" style="padding: 2px;">
                                <select #state="ngModel" class="input_field chevrronDown  p-3 w-100 border-0 sm-16 select2 text-dark" name="state" ngModel id="state" (change)="get_fipartners($event.target.value)" required>
                                    <option  value="" disabled selected>Province</option>
                                    <option *ngFor="let state of states" [value]="state.key">
                                        {{state.value}}                                    </option>
                                    </select>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <small class="sm-12 grey-text">{{ fi_name }}</small>
                                    </div>
                                  <div class="col-6">
                                    <img class="fi-img" [src]="fi_logolink" />
                                  </div>
                                  
                                    
                                </div>
                                <small class="sm-12 text-secondary mt-3" [innerHTML]="fi_disclaimer"></small>
                                <div class="d-flex justify-content-around address_field my-4">
                                    <button (click)="goTo('name')" type="button" class="btn transparent primary-text sm-12 back-btn">Back</button>          
                                    <button [disabled]="!state.valid" (click)="goTo('phone')" type="button" class="btn primary-btn w-100 sm-12 h-auto">Next</button>
                                </div>
                            </ng-container>
                        </div>
                        <div  [ngClass]="{'d-none': step!='phone'}" >
                            <h6 class="font-weight-bold sm-18 primary-text">Verify your phone number</h6>
                            <small *ngIf="!isMobileVerified && !mob_num" class="sm-12 text-grey mobile16">Next, verify your number by entering the one time password (OTP) sent to the above number.</small>
                            <small *ngIf="!isMobileVerified && mob_num" class="sm-12 text-grey mobile16">Please enter OTP</small>
                            <div *ngIf="!isMobileVerified && !mob_num" class="input-group w-100 d-flex justify-content-between flex-wrap mt-2">
                                <div class="input-group-prepend col-1 input_field text-center align-items-center box-shadows pl-4">
                                    +
                                </div>
                                <div class="col-1 p-0 box-shadows">
                                    <input type="number" minlength="1" maxlength="3" autocomplete="off"
                                    [(ngModel)]="country_code"  class="input_field py-3 text-center w-100" name="country_code" required
                                    placeholder="" (keydown)="common.checkNumber($event, 3)">
                                </div>
                                <div class="col-9 p-0 box-shadows">
                                    <input type="number" minlength="10" maxlength="10" autocomplete="off"
                                    [(ngModel)]="typedNumber"  class="input_field p-3 w-100" name="mob_num" required
                                    placeholder="Your phone number" (keydown)="common.checkNumber($event, 10)">
                                </div>
                                
                                <span id="show_verify_button" class="w-100"></span>
                                <div class="d-flex justify-content-end w-100">
                                    
                                </div>
                            </div>
                            <div *ngIf="!isMobileVerified && mob_num" class="input-group w-100 mt-2">
                                <input [(ngModel)]="typedOTP" type="text" autocomplete="off" maxlength="6"
                                [ngModelOptions]="{standalone: true}" class="input_field p-3 w-100  box-shadows" required
                                placeholder="Received OTP" />
                                <a *ngIf="!isMobileVerified" class="sm-12 text-right w-100 pr-3" (click)="changeNumber()">Resend OTP / Change number</a>
                                
                                <span id="show_verify_button"></span>
                                <div class="d-flex justify-content-end w-100">
                                    <!-- <button type="button" class="btn primary-btn sm-12 px-5 ml-auto mt-3 button-fixed" (click)="verifyOTP()">
                                        Verify OTP
                                    </button> -->
                                </div>
                                
                            </div>
                            <input type="text" class="input_field p-3 w-100" [(ngModel)]="mob_num" [ngModelOptions]="{standalone: true}"
                            *ngIf="isMobileVerified" disabled="true">
                            <div *ngIf="isMobileVerified" class="text-success py-2 sm-12 mobile16">Verified successfully</div>
                            
                            <br>
                            
                            <div class="d-flex justify-content-between address_field otp_verify">
                                <button (click)="goTo('address')" type="button" class="btn transparent primary-text back-btn sm-12">Back</button>
                                <button *ngIf="!isMobileVerified && !mob_num" type="button" class="btn primary-btn  sm-12 h-auto  w-100 button-fixed" (click)="sendOTP()" [disabled]="typedNumber.toString().length != 10 || !country_code">Send OTP</button>
                                <button *ngIf="!isMobileVerified && mob_num" type="button" class="btn primary-btn  sm-12 h-auto  w-100 button-fixed" (click)="verifyOTP()">Verify OTP</button>
                                <button *ngIf="isMobileVerified && auth.user.country_id==233" type="submit" class="btn primary-btn  sm-12 h-auto w-100 button-fixed">Next</button>
                                <button *ngIf="isMobileVerified && auth.user.country_id==39" type="submit" class="btn primary-btn  sm-12 h-auto w-100 button-fixed">Finish</button>
                            </div>
                        </div>
                        <div *ngIf="step=='document'">
                            <app-verify-document *ngIf="auth.user.country_id==233"></app-verify-document>
                            <!-- <app-ca-document *ngIf="auth.user.country_id==39"></app-ca-document> -->
                        </div>
                        <div *ngIf="step=='payment'">
                            <div class="d-flex ml-4 mt-3">
                                <a (click)="goBack()" type="button" class="link sm-12">Cancel</a>
                                <button (click)="goTo('address')" class="btn btn-grey text-light ml-5 py-1 px-4 h-auto sm-12">Next</button>
                            </div>
                        </div>
                        
                    </div>
                    
                </div>
            </form>
        </div>
        
        
        <!-- <div class="w-100 d-flex align-items-end justify-content-center">
            <p class="h3 text-center color-blue font-weight-bold customPage-heading">Personal Profile</p>
        </div>
        <div *ngIf="auth.user" id="edit-personal-details" class="accord bg-offwhite shadow personal-detailsForm shadow-box ">
            <div *ngIf="mode=='edit'" class="content-edit-area">
                <div class="edit-header mt-3">
                    <h5 class="title pl-2 font-weight-bold">Personal Information</h5>
                </div>
                <div class="edit-content">
                    <form #updateUserForm="ngForm" class="account-form" (ngSubmit)="updateUser(updateUserForm)">
                        <button (click)="mode='display'">Close</button>
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label class="form-label pt-2" for="firstName">First Name<span
                                        class="text-danger">*</span></label>
                                        <input type="text" name="name" [(ngModel)]="auth.user.name"
                                        class="form-control personal-field" data-pr-form="firstName" id="firstName"
                                        placeholder="First Name" required>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="form-group">
                                        <label class="form-label pt-2" for="fullName">Last Name<span
                                            class="text-danger">*</span></label>
                                            <input name="lastname" [(ngModel)]="auth.user.lastname" type="text" value="Doue"
                                            class="form-control personal-field" data-pr-form="fullName" id="fullName"
                                            placeholder="Full Name" required>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="form-group">
                                                    <label class="form-label" for=" emailID">Email ID <span
                                                        class="text-muted font-weight-500">(Primary)<span
                                                        class="text-danger">*</span></span></label>
                                                        <input disabled name="email_id" [(ngModel)]="auth.user.email" type="text"
                                                        value="demo@company.com " class="form-control email " data-pr-form="emailid"
                                                        id="emailID" required placeholder="Email ID">
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <label class="form-label" for="mobile-number">Mobile (Primary)
                                                <span class="text-muted font-weight-500"></span>
                                                <span style="color:red;">*</span>
                                            </label>
                                            <div *ngIf="!isMobileVerified && !mob_num" class="input-group">
                                                <div class="input-group-prepend">
                                                    <span style="background: lightgrey;" class="input-group-text"
                                                    id="basic-addon1">+1</span>
                                                </div>
                                                <input type="number" minlength="10" maxlength="10" autocomplete="off"
                                                [(ngModel)]="typedNumber" class="form-control personal-field" name="mob_num" required
                                                placeholder="Primary 10 digit mobile number">
                                                <span id="show_verify_button"></span>
                                                <button type="button" class="btn customButton ml-2" (click)="sendOTP()">Send Otp</button>
                                            </div>
                                            <div *ngIf="!isMobileVerified && mob_num" class="input-group">
                                                <div class="input-group-prepend">
                                                    <span style="background: lightgrey;" class="input-group-text"
                                                    id="basic-addon1">OTP</span>
                                                </div>
                                                <input [(ngModel)]="typedOTP" type="text" autocomplete="off"
                                                [ngModelOptions]="{standalone: true}" class="form-control personal-field" required
                                                placeholder="Enter Received OTP">
                                                <span id="show_verify_button"></span>
                                                <button type="button" class="btn customButton" (click)="verifyOTP()">Verify Otp</button>
                                            </div>
                                            <input type="text" [(ngModel)]="mob_num" [ngModelOptions]="{standalone: true}"
                                            *ngIf="isMobileVerified" disabled="true">
                                            <div *ngIf="isMobileVerified" class="text-success">Verified Successfully</div>
                                            <a *ngIf="!isMobileVerified" (click)="changeNumber()">Change number</a>
                                        </div>
                                        <div *ngIf="auth.user.country_id==39" class="col-12 mt-3">
                                            <div class="form-group custom-wrap1">
                                                <label class="form-label" for="input-zone">Country</label>
                                                <span style="color:red;">*</span>
                                                <select ngModel class="custom-select" class="w-100 p-2" name="country" required>
                                                    <option value="" disabled selected> --- Please Select ---</option>
                                                    <option [value]="country.id" *ngFor="let country of countries">{{country.name}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div *ngIf="auth.user.country_id==39" class="col-6 ">
                                            <div class="form-group">
                                                <label class="form-label" for="firstName">City<span class="text-danger">*</span></label>
                                                <input type="text" name="city_name" ngModel class="form-control personal-field"
                                                placeholder="Recipient City Name" required>
                                            </div>
                                        </div>
                                        <div *ngIf="auth.user.country_id==39" class="col-6 ">
                                            <div class="form-group">
                                                <label for="fullName">Zip Code/Postal Code<span class="text-danger">*</span></label>
                                                <input type="text" name="pin_code" ngModel class="form-control personal-field"
                                                placeholder="Recipient Postal Code" required>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="form-group custom-wrap1 form-label">
                                                <label for="input-zone">Province/State* </label>
                                                <span style="color:red;">*</span>
                                                <select class="select2" class="w-100 p-2" name="state" ngModel id="state" required>
                                                    <option value="" disabled selected> --- Please Select ---</option>
                                                    
                                                    <option *ngFor="let state of states" [value]="state.key">
                                                        {{state.value}}
                                                    </option>
                                                    
                                                </select>
                                            </div>
                                        </div>
                                        
                                        <div *ngIf="auth.user.country_id==39" class="col-12">
                                            <div class="form-group">
                                                <label class="form-label" for="address">Address<span class="text-danger">*</span></label>
                                                <input type="text" name="user_address" ngModel class="form-control personal-field"
                                                placeholder="Address" required>
                                            </div>
                                        </div>
                                        <div *ngIf="auth.user.country_id==39" class="col-12">
                                            <div class="form-group">
                                                <label class="form-label" for="address">Street<span class="text-danger">*</span></label>
                                                <input type="text" name="user_street" ngModel class="form-control personal-field"
                                                id="street" placeholder="Street" required>
                                            </div>
                                        </div>
                                        <div *ngIf="auth.user.country_id==39" class="col-12">
                                            <div class="form-group">
                                                <label class="form-label" for="dob">Date of Birth<span class="text-danger">*</span></label>
                                                <input name="dob" ngModel type="date" class="form-control personal-field" required>
                                            </div>
                                        </div>
                                        <button [disabled]="!isMobileVerified || !updateUserForm.valid" type="submit"
                                        class="btn w-100 m-3 customButton">Save Changes</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div *ngIf="mode=='display'">
                            <div class="container border mt-5">
                                <div class="text-center  font-weight-bold info-heading" style="padding:16px 0px;">
                                    Personal Information<span class="float-right"><a *ngIf="isUpdateble()" (click)="mode='edit'">Update <i
                                        class="fas fa-edit mr-1"></i></a></span>
                                    </div>
                                    <div class="row info-field border-top py-2">
                                        <div class="col-6">
                                            <div class="row">
                                                <div class="col-6">
                                                    <p>First Name</p>
                                                </div>
                                                <div class="col-6">
                                                    <p>{{auth.user.name}}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="row">
                                                <div class="col-6">
                                                    <p>last Name</p>
                                                </div>
                                                <div class="col-6">
                                                    <p>{{auth.user.lastname}}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row info-field">
                                        <div class="col-6">
                                            <div class="row">
                                                <div class="col-6">
                                                    <p>Accout Status</p>
                                                </div>
                                                <div class="col-6">
                                                    <span *ngIf="isUpdateble()" class="text-danger" data-toggle="tooltip"
                                                    data-original-title="Inactive">
                                                    <i class="far fa-times-circle"></i>
                                                </span>
                                                <span *ngIf="!isUpdateble()" class="text-success" data-toggle="tooltip"
                                                data-original-title="Inactive">
                                                <i class="far fa-check-circle"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <div class="row info-field">
                                <div class="col-6">
                                    <div class="row">
                                        <div class="col-6">
                                            <p>Email</p>
                                        </div>
                                        <div class="col-6">
                                            <p>{{auth.user.email}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <div class="row info-field ">
                                <div class="col-6">
                                    <div class="row">
                                        <div class="col-6">
                                            <p>Mobile</p>
                                        </div>
                                        <div class="col-6">
                                            <p>
                                                {{auth.user.mob_num}}
                                                <span *ngIf="auth.user.mob_verified" class="text-success" data-toggle="tooltip"
                                                data-original-title="Inactive">
                                                <i class="far fa-check-circle"></i>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="row info-field">
                            <div class="col-6">
                                <div class="row">
                                    <div class="col-6">
                                        <p>State</p>
                                    </div>
                                    <div class="col-6">
                                        <p>{{auth.user.state_name}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
            